const ENTITY_FIELD_TYPE = {
  PARAGRAPH: 'PARAGRAPH',
  PRIMARY: 'PRIMARY',
  RELATIONSHIP: 'RELATIONSHIP',
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  DECIMAL: 'DECIMAL',
  DATE: 'DATE',
  DATE_TIME: 'DATE_TIME',
  DROPDOWN: 'DROPDOWN',
  CHECKBOX: 'CHECKBOX',
  MULTI_SELECT: 'MULTI_SELECT',
  CREATED_AT: 'CREATED_AT',
  UPDATED_AT: 'UPDATED_AT',
  DROPDOWN_LOOKUP: 'DROPDOWN_LOOKUP',
  DROPDOWN_LOOKUP_SECTION: 'DROPDOWN_LOOKUP_SECTION',
};

export default ENTITY_FIELD_TYPE;
